import ActionTypes from './ActionTypes'
import produce from 'immer'

/** @type {IMerchantQueryParams} */
export const initialParams = {
  limit: 10,
  skip: 0,
  query: '',
}

export const initialTags = {
  data: [],
  meta: {},
}
/** @type {IMerchantState} */
export const initialState = {
  isInit: false,
  data: [],
  meta: {
    perPage: 10,
    currentPage: 1,
    total: 0,
  },
  params: initialParams,
  tags: initialTags,
}

export default produce(
  /**
   *  @param {IMerchantState} draft
   *  @param {IAction} action
   */
  (draft, action) => {
    switch (action?.type) {
      case ActionTypes.INIT: {
        draft.isInit = true
        break
      }
      case ActionTypes.RESET_DATA: {
        return initialState
      }
      case ActionTypes.UPDATE_DATA: {
        const { data } = action.payload
        draft.data = data
        break
      }
      case ActionTypes.UPDATE_META: {
        const { total } = action.payload
        draft.meta = { ...draft.meta, total }
        break
      }
      case ActionTypes.UPDATE_PARAMS: {
        const { params } = action.payload
        draft.params = params
        draft.meta.currentPage = (params.skip / draft.meta.perPage) + 1
        break
      }
      default:
        break
    }
  },
  initialState,
)
